export class  SearchModel {
  obligorName: string;
  stateAbbr: string;
  stateId: string;
  cusip: string;
  pageSize: number;
  currentPage: number;
}
